import * as React from 'react';

import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';

import { motion } from 'framer-motion';

export interface SnackbarBaseProps {
  className?: string;
  isCentered?: boolean;
  content: React.ReactNode;
  actions: React.ReactNode;
}

export const SnackbarBase: React.FC<SnackbarBaseProps> = (props) => {
  const SnackbarAnimation = {
    visible: {
      opacity: 1,
      bottom: 0,
      transition: {
        duration: 0.5,
      },
    },
    hidden: {
      opacity: 0,
      bottom: -100,
    },
  };

  return (
    <motion.div
      className={props.className}
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={SnackbarAnimation}
    >
      <Flex
        className="snackbar-wrapper"
        justifyContent="space-between"
        alignItems="center"
      >
        <div className="text-wrapper">{props.content}</div>
        <div className="actions-wrapper">{props.actions}</div>
      </Flex>
    </motion.div>
  );
};

export default styled(SnackbarBase)`
  border-radius: 1px;
  box-sizing: border-box;

  ${(props) =>
    props.isCentered
      ? css`
          .snackbar-wrapper {
            flex-direction: column;
            @media ${({ theme }) => theme.device.tablet} {
              flex-direction: row;
            }
          }

          .actions-wrapper {
            margin-top: 15px;
            @media ${({ theme }) => theme.device.tablet} {
              margin-top: 0;
            }
          }
        `
      : null}

  .text-wrapper,
  .actions-wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 100%;
  }

  @media ${({ theme }) => theme.device.tablet} {
    .text-wrapper {
      flex-basis: 60%;
    }

    .actions-wrapper {
      flex-basis: 40%;
    }
  }
`;
